import React, { useEffect, useState, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Base64 } from "js-base64";
import {
  validateAndSubmit,
  handleInputChange,
  handleBlur,
  submitInformation,
  handleCustomInputChange,
} from "../../../utils/checkout";

import DashboardHotelBookHero from "../../components/dashboard-hotel-book/hero/component";
import InformationCard from "../../components/dashboard-hotel-book/information-card/component";
import GuestCard from "../../components/dashboard-hotel-book/guest-card/component";
import PaymentSummaryCard from "../../components/dashboard-hotel-book/payment-summary/component";
import BookingDiscount from "../../components/dashboard-hotel-book/booking-discount-aside/component";
import DashboardHotelBookSkeleton from "../../components/dashboard-hotel-book/dashboard-hotel-book-skeleton/component";
import InformationCardSkeleton from "../../components/dashboard-hotel-book/information-card-skeleton/component";
import BookingSummarySkeleton from "../../components/dashboard-hotel-book/booking-discount-aside-skeleton/component";
import DashboardHotelConfirm from "../dashboard-hotel-confirm/component";
import { QUERY_PARAMS, ROOMS_UNAVAILABLE_ERROR } from "../../../constants/index";
import { formatMoneyCurrency } from "../../../utils/currency";

import isUndefined from 'lodash/isUndefined';
import { connect, useDispatch } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Modal } from 'antd';

import {
  getReviewBook,
  getHotelDetails,
  setExpiredSession,
  setLoadingBook,
  IReviewBookState,
  setReviewBook,
  resetState,
  IHotelDetailsState,
  IRoomsSearchState,
  setBookingComplete,
} from '@store/slices';
import { IBookingSummary } from '@common-types';
import { ISessionKey } from '@share/common-types';
import { UrlUtils, getTimeout, getSessionObj, getHotelRoutePath, getHotelIdFromPath, getPackageIdFromPath, RootState, navigateBack } from '@share/utils';
import { SESSION_KEY_LABEL_ROOMS, SESSION_KEY_LABEL, QUOTE_LABEL, LIFE_STYLE_NAME_PARAM, Routes } from '@share/constants';
import { HOTEL_SESSION_KEY, NULL_VALUE } from '@constants';
import { IHotelsState, ILoginState, IMenuState, voucherBooking } from '@share/store/slices';
import { ReviewBook } from "../../components/review-book/review-book/review-book";
import { VoucherModal } from "@components";
import { FormattedMessage } from "react-intl";
import { push } from "react-router-redux";
import { BlueButton, CustomErrorPage } from "@share/components";
import "./style.scss"
import NoHotelResults from '@share/assets/images/no_hotel_results.png';
import { AvailabilityError } from "../../components/review-book/notification/availability-error/component";
interface IMapStateToProps {
  hotelsStore: IHotelsState;
  reviewBookStore: IReviewBookState;
  hotelDetailsStore: IHotelDetailsState;
  roomsSearchStore: IRoomsSearchState;
  menuStore: IMenuState;
  loginStore: ILoginState;
}

interface IMapDispatchToProps {
  getReviewBook: (hotelId: number, packageId: string, sessionKey: ISessionKey, lifeType: string, quote?: string) => void;
  setExpiredSession: (expiredSession: boolean) => void;
  setLoadingBook: (loadingBook: boolean) => void;
  setReviewBook: (data: IBookingSummary) => void;
  resetState: () => void;
  getHotelDetails: (hotelId: number, sessionKey: ISessionKey, dealId?: number, quote?: string) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps {
  // isVacationRentals: boolean;
}

const ZERO = 0;
const MODAL_WIDTH = 400;

interface RouteParams {
  id: string;
  packageId: string;
}

function DashboardHotelBookComponent(props: IProps) {
  const location = useLocation();
  const { id, packageId } = useParams<RouteParams>();
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(location.search);
  const parsedHotelId = id ? JSON.parse(id) : null;
  const sessionKey = JSON.parse(
    Base64.decode(queryParams.get(QUERY_PARAMS.SESSION_KEY) ?? "null")
  );

  const [expirationTimeout, setExpirationTimeout] = useState<any>(NULL_VALUE);
  const [orderResponse, setOrderResponse] = useState({});
  const [showBookCard, setShowBookCard] = useState(false);
  const [cardType, setCardType] = useState("");
  const [useCreditLine, setUseCreditLine] = useState(false);
  const [showVoucherModal, setShowVoucherModal] = useState(false);
  const [email, setEmail] = useState('');
  const [emailAdditional, setEmailAdditional] = useState('');
  const [isAdditionalEmailAdded, setIsAdditionalEmailAdded] = useState(false);

  const handleVoucherBooking = (recepientEmail: string, additionalEmail: string) => {
    const bookingID = props?.reviewBookStore.booking?.hotelSegments[0]?.bookingGuid;
    dispatch(voucherBooking(bookingID, recepientEmail, additionalEmail, () => setShowVoucherModal(false)));
  }
  const setEmailModal = (emailParam: string) => {
    setEmail(emailParam);
  };

  const setEmailAdditionalModal = (emailAdditionalParam: string) => {
    setEmailAdditional(emailAdditionalParam);
  };

  const setIsAdditionalEmailAddedModal = (isAdditionalEmailAddedParam: boolean) => {
    setIsAdditionalEmailAdded(isAdditionalEmailAddedParam);
  };

  const onExpiredSession = (sessionData: ISessionKey) => {
    const expireDate = sessionData.expireDate;

    if (getTimeout(expireDate) < ZERO) {
      props.setExpiredSession(true);
    } else {
      setExpirationTimeout({
        // @ts-ignore
        expirationTimeout: setTimeout(() => {
          props.setExpiredSession(true);
        }, getTimeout(expireDate)),
      });
    }
  };


  const getBookingSummary = () => {
    const { loginStore } = props;
    const { user, account } = loginStore;

    if (!!user && !!account) {
      const values = UrlUtils.getValues();
      const sessionKey = getSessionObj(
        values[SESSION_KEY_LABEL_ROOMS] as ISessionKey,
        values[SESSION_KEY_LABEL] as ISessionKey,
      );

      const sessionStorage = localStorage.getItem(HOTEL_SESSION_KEY);
      const currentSessionKey = !isUndefined(sessionKey)
        ? sessionKey
        : sessionStorage ? JSON.parse(sessionStorage) : null;

      const { roomsSearchStore, hotelDetailsStore } = props;
      const hotel = roomsSearchStore.hotel ? roomsSearchStore.hotel : hotelDetailsStore.hotel;
      if (!hotel) {
        props.getHotelDetails(Number(id), currentSessionKey);
      }

      let quote;
      if (values[QUOTE_LABEL]) {
        quote = (values[QUOTE_LABEL] as string);
      }

      let lifeType = 'none';
      if (UrlUtils.getSearchParam(LIFE_STYLE_NAME_PARAM)) {
        lifeType = UrlUtils.getSearchParam(LIFE_STYLE_NAME_PARAM) as string;
      }

      props.setLoadingBook(true);
      props.setReviewBook(NULL_VALUE);
      props.getReviewBook(Number(id), packageId, currentSessionKey, lifeType, quote as string);
    }
  }

  useEffect(() => {
    if (props.reviewBookStore.bookingComplete === true) {
      setOrderResponse(props.reviewBookStore.booking);
      setShowBookCard(true);
    }
  }, [props.reviewBookStore.bookingComplete]);

  useEffect(() => {
    const { menuStore } = props;
    const { items } = menuStore;

    const values = UrlUtils.getValues();
    const sessionKey = getSessionObj(
      values[SESSION_KEY_LABEL_ROOMS] as ISessionKey,
      values[SESSION_KEY_LABEL] as ISessionKey,
    );

    if (!isUndefined(sessionKey)) {
      localStorage.setItem(HOTEL_SESSION_KEY, JSON.stringify(sessionKey));
    }

    const sessionStorage = localStorage.getItem(HOTEL_SESSION_KEY);
    const currentSessionKey = !isUndefined(sessionKey)
      ? sessionKey
      : sessionStorage ? JSON.parse(sessionStorage) : null;

    if (items) {
      // getBookingSummary();
    }

    onExpiredSession(currentSessionKey);

    window.scrollTo(ZERO, ZERO);

    return () => {
      clearTimeout(expirationTimeout);
      props.resetState();
      props.setReviewBook(NULL_VALUE);
    }
  }, []);

  useEffect(() => {
    getBookingSummary();
  }, [location.search]);

  useEffect(() => {
    if (props.reviewBookStore?.guests?.[0]?.email) {
      setEmail(props.reviewBookStore?.guests?.[0]?.email);
    }
  }, [props.reviewBookStore?.guests]);

  const handleNavigateToSearch = () => {
    setExpirationTimeout(NULL_VALUE);
    setOrderResponse({});
    setShowBookCard(false);
    setCardType("");
    setUseCreditLine(false);
    setShowVoucherModal(false);
    setEmail('');
    setEmailAdditional('');
    setIsAdditionalEmailAdded(false);
    props.resetState();
    props.setReviewBook(NULL_VALUE);
    dispatch(push(`/${account?.name}${Routes.HotelDashboard}`));
  };

  // componentDidUpdate(prevProps: Readonly<IProps>): void {
  //     const { loginStore, menuStore, reviewBookStore } = this.props;
  //     const { account, user, userWalletData } = loginStore;
  //     const { items } = menuStore;
  //     const { loading, bookingSummary } = reviewBookStore;

  //     const userLoaded = !prevProps.loginStore.user && !!user;
  //     const walletLoaded = !prevProps.loginStore.userWalletData && !!userWalletData && account?.hasClientCash;
  //     const menuLoaded = !prevProps.menuStore.items && !!items && !loading && !bookingSummary;

  //     if (userLoaded || walletLoaded || menuLoaded) {
  //       this.getBookingSummary();
  //     }
  //   }

  const { reviewBookStore, loginStore } = props;
  const { account } = loginStore;
  const {
    loading,
    bookingSummary,
    booking,
    bookingComplete,
    guests,
    isExternalError,
    error,
  } = reviewBookStore;

  const { roomsSearchStore, hotelDetailsStore } = props;
  const hotel = roomsSearchStore.hotel ? roomsSearchStore.hotel : hotelDetailsStore.hotel;
  const hasTVP = hotel?.adjustedPackageGroups?.some(item =>
    item.groupedPackages.some(pkg => pkg.supplierId === "TVP")
  ) ?? false;

  const isRoomUnavaliableError = error === ROOMS_UNAVAILABLE_ERROR;

  const inErrorPage = isExternalError && isRoomUnavaliableError;
  const buttonColor = account?.buttonColor;

  return (
    <div>
      {(loading || inErrorPage) ? (
        <>
          <DashboardHotelBookSkeleton />
          <section>
            <div className="container">
              <div className="row checkout-page-row">
                <div className="col-xl-8">
                  <div className="vstack gap-5">
                    <InformationCardSkeleton />
                  </div>
                </div>
                <aside className="col-xl-4">
                  <BookingSummarySkeleton />
                </aside>
              </div>
            </div>
          </section>
        </>
      ) : (
        <>
          <DashboardHotelBookHero bookingStatus={bookingComplete} roomsData={bookingSummary?.bookingCard} />
          <section className="pt-4">
            <div className="container">
              <div className="row checkout-page-row">
                <div className={bookingSummary?.bookingCard === undefined ? "col-xl-12" : "col-xl-8"}>
                  <div className="vstack gap-5">
                    {showBookCard ? 
                      <>
                        <DashboardHotelConfirm
                          searchHotels={bookingSummary}
                          orderResponse={booking}
                          guests={guests}
                          onVoucher={() => setShowVoucherModal(true)}
                        />
                        <div className="mb-2 mt-1 pb-2 border-bottom d-flex justify-content-center">
                          <button type="button" className="backBtn p-0 btn btn-link" onClick={handleNavigateToSearch} style={{ color: `${buttonColor}`  }}>
                            <FormattedMessage id="back.to.search" />
                          </button>
                        </div>
                        <VoucherModal
                          visible={showVoucherModal}
                          loading={loading}
                          onCancel={() => setShowVoucherModal(false)}
                          onVoucher={handleVoucherBooking}
                          email={email}
                          emailAdditional={emailAdditional}
                          isAdditionalEmailAdded={isAdditionalEmailAdded}
                          setEmailModal={setEmailModal}
                          setEmailAdditionalModal={setEmailAdditionalModal}
                          setIsAdditionalEmailAddedModal={setIsAdditionalEmailAddedModal}
                        />
                      </> : (
                      <>
                        {bookingSummary?.bookingCard && !inErrorPage ? (
                          <InformationCard
                            searchHotels={bookingSummary}
                            getBookingSummary={getBookingSummary}
                            hasTVP={hasTVP}
                          />) : 
                          <>
                            <div className="roomUnavailableLogo">
                              <CustomErrorPage isHotel={true} message={error} hotelId={id} isCheckout />
                            </div>
                          </>}

                        {bookingSummary && !loading && (
                          <ReviewBook isVacationRentals={false} />
                        )}
                      </>
                    )}
                  </div>
                </div>
                {bookingSummary && !loading && (
                <aside className="col-xl-4">
                    <BookingDiscount
                      formatter={formatMoneyCurrency(bookingSummary?.bookingCard?.package?.currency)}
                      balance={bookingSummary?.bookingCard?.balance}
                      totalFarePrice={bookingSummary?.bookingCard?.bookingPrice?.totalFarePrice}
                      nightsCount={bookingSummary?.bookingCard?.nightsCount}
                      roomsCount={bookingSummary?.bookingCard?.roomsCount}
                      savings={bookingSummary?.bookingCard?.bookingPrice?.savings}
                      taxes={bookingSummary?.bookingCard?.bookingPrice?.totalTaxes}
                      searchHotels={bookingSummary}
                      showBookCard={showBookCard}
                    />
                </aside>
                  )}
              </div>
            </div>
          </section>
        </>
      )}

      <Modal
        className="price-change-modal-wrapper"
        wrapClassName="price-change-modal-wrapper__wrap"
        open={isRoomUnavaliableError && isExternalError}
        footer={null}
        title={null}
        closable={false}
        keyboard={false}
        destroyOnClose={true}
        width={MODAL_WIDTH}
      >
        <AvailabilityError isVacationRentals={false} />
      </Modal>

    </div>
  );
};

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    menuStore: state.navigationMenuStore,
    hotelsStore: state.hotelsStore,
    reviewBookStore: state.reviewBookStore,
    loginStore: state.loginStore,
    hotelDetailsStore: state.hotelDetailsStore,
    roomsSearchStore: state.roomsSearchStore
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getReviewBook,
  getHotelDetails,
  setExpiredSession,
  setLoadingBook,
  setReviewBook,
  resetState,
};

const DashboardHotelBook = connect(mapStateToProps, mapDispatchToProps)(withRouter(DashboardHotelBookComponent));
export default DashboardHotelBook;